import { GetUserDetails } from "./config";

export const checkUserLogin = () => {
  const user_details = GetUserDetails();
  // console.log("checking user login status")
  try {
    const pathname = window.location.pathname;

    if (
      !user_details &&
      pathname !== "/login" &&
      pathname !== "/register" &&
      pathname !== "/"
    ) {
      goToLoginUrlWithRedirect();
      // location.href = `${location.origin}/login?&redirect=${redirect_url}`;
    }
  } catch (error) {
    console.log("error in checking user login", error);
  }
};

export const goToLoginUrlWithRedirect = () => {
  //const redirect_url = window.location.href;
  goToUrlWithRedirect("login", "dashboard");
};

export const goToUrlWithRedirect = (path, redirectUrl) => {
  window.location.href = `${window.location.origin}/${path}?&redirect=${redirectUrl}`;
};

export const redirectOnAuthSuccess = (fullRedirectUrlHref) => {
  console.log("redirect url", fullRedirectUrlHref);
  window.location.href = fullRedirectUrlHref || window.location.origin;
};

export const logoutAndClearCache = () => {
  console.log("About to logout and clear cache");
  localStorage.clear();
  sessionStorage.clear();
  window.location.reload();
};


